import { render, staticRenderFns } from "./VueAnkaCropper.vue?vue&type=template&id=3aef7a9c"
import script from "./VueAnkaCropper.vue?vue&type=script&lang=js"
export * from "./VueAnkaCropper.vue?vue&type=script&lang=js"
import style0 from "./VueAnkaCropper.vue?vue&type=style&index=0&id=3aef7a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports